import React from "react";
import { useStores } from "../../store";
import { MdControlPoint, MdDeleteOutline } from "react-icons/md";
import { useState } from "react";

import { useObserver } from "mobx-react";
import { AiFillCloseCircle } from "react-icons/ai";
import { useEffect } from "react";
export default function Experience({ popUpInitialValue, handlePopup }) {
  const { UserStore } = useStores();
  const [experiences, setExperiences] = useState([
    {
      company: "",
      designation: "",
      joiningDate: "",
      completionDate: "",
    },
  ]);
  useEffect(() => {
    if (UserStore?.userexperience) {
      setExperiences(UserStore?.userexperience);
    }
    console.log(UserStore?.userexperience);
  }, []);
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const newExperiences = [...experiences];
    newExperiences[index][name] = value;
    setExperiences(newExperiences);
  };

  const handleAddExperience = () => {
    setExperiences([
      ...experiences,
      {
        company: "",
        designation: "",
        joiningDate: "",
        completionDate: "",
      },
    ]);
  };

  const handleDeleteExperience = (index) => {
    const newExperiences = [...experiences];
    newExperiences.splice(index, 1);
    setExperiences(newExperiences);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(experiences);
    UserStore.setUserExperience(experiences);
    console.log(UserStore?.userExperience);
    handlePopup();
  };

  const closeThisPopUP = () => {
    handlePopup();
  };

  return useObserver(() => (
    <>
      {popUpInitialValue ? (
        <div
          className="absolute w-screen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
          onClick={closeThisPopUP}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="fixed  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded items-center md:w-[60%] lg:w-[60%] w-[90%] h-[75%] md:h-[70%] lg:h-[70%] m-auto shadow-lg overflow-y-auto no-scrollbar"
          >
            <div className="flex flex-col justify-between  h-full py-5 w-[100%] md:w-[100%] lg:[100%] border ">
              <AiFillCloseCircle
                className="text-primary absolute text-2xl cursor-pointer  top-2 right-2"
                onClick={closeThisPopUP}
              />
              <form onSubmit={handleSubmit}>
                <p className="px-14 font-semibold lg:text-2xl">Experience</p>
                {experiences?.map((experience, index) => (
                  <div className="relative">
                    <div
                      key={index}
                      className="md:grid md:grid-cols-2 gap-4 p-6 border-b lg:text-3xl hover:relative"
                    >
                      <div className="flex justify-end -mb-8 mr-2 mt-2 absolute top-0 right-0 opacity-50 text-lg  hover:opacity-100">
                        <button
                          type="button"
                          className=""
                          onClick={() => handleDeleteExperience(index)}
                        >
                          <MdDeleteOutline></MdDeleteOutline>
                        </button>
                      </div>
                      <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                        <label
                          htmlFor={`company${index}`}
                          className="form-label lg:text-xl"
                        >
                          Company Name
                        </label>
                        <input
                          type="text"
                          className="form-control border border-text_color5 p-3 mt-1 h-10 text-gray-500 lg:h-12 lg:text-xl"
                          id={`company${index}`}
                          name="company"
                          value={experience.company}
                          onChange={(e) => handleInputChange(index, e)}
                          required
                        />
                      </div>
                      <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                        <label
                          htmlFor={`designation${index}`}
                          className="form-label lg:text-xl"
                        >
                          Designation
                        </label>
                        <input
                          type="text"
                          className="form-control border border-text_color5 p-3 mt-1 h-10 text-gray-500 lg:h-12 lg:text-xl"
                          id={`designation${index}`}
                          name="designation"
                          value={experience.designation}
                          onChange={(e) => handleInputChange(index, e)}
                          required
                        />
                      </div>
                      <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                        <label
                          htmlFor={`joiningDate${index}`}
                          className="form-label lg:text-xl"
                        >
                          Date of Joining
                        </label>
                        <input
                          type="date"
                          className="form-control border border-text_color5 p-3 mt-1 h-10 text-gray-500 lg:h-12 lg:text-xl"
                          id={`joiningDate${index}`}
                          name="joiningDate"
                          value={experience.joiningDate}
                          onChange={(e) => handleInputChange(index, e)}
                          required
                        />
                      </div>
                      <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                        <label
                          htmlFor={`completionDate${index}`}
                          className="form-label lg:text-xl"
                        >
                          Date of Completion
                        </label>
                        <input
                          type="date"
                          className="form-control border border-text_color5 p-3 mt-1 h-10 text-gray-500 lg:h-12 lg:text-xl"
                          id={`completionDate${index}`}
                          name="completionDate"
                          value={experience.completionDate}
                          onChange={(e) => handleInputChange(index, e)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <div className="flex flex-row items-center justify-end">
                  <button
                    type="button"
                    className="flex flex-row items-center w-fit pr-[2%] mt-2 text-sm text-primary"
                    onClick={handleAddExperience}
                  >
                    <MdControlPoint></MdControlPoint> Add Experience
                  </button>
                </div>

                <div className="flex justify-end items-center pr-10 gap-4 mt-4">
                  <button
                    type="submit"
                    className="border bg-primary text-white   rounded-xl w-24 h-12"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : null}
    </>
  ));
}
